import { render, staticRenderFns } from "./dispatchWithdrawalRule.vue?vue&type=template&id=7fb4166e"
import script from "./dispatchWithdrawalRule.vue?vue&type=script&lang=js"
export * from "./dispatchWithdrawalRule.vue?vue&type=script&lang=js"
import style0 from "./dispatchWithdrawalRule.vue?vue&type=style&index=0&id=7fb4166e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports